export default {
    FETCH_POLICY: 'fetchPolicy',
    FETCH_CATEGORIES: 'fetchCategories',
    FETCH_ANNOUNCEMENT: 'fetchAnnouncement',
    FORCE_CARD_CREATED: 'forceCardCreated',
    INITIALIZE_CARD_INFO: 'initializeCardInfo'
}


// WEBPACK FOOTER //
// ./src/constant.js